import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";
import { userSchema } from "../user";
import {
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_PRIORITIES,
  NotificationCategorySchema,
  NotificationPrioritySchema,
  notificationDataSchema,
} from "./create";

export const notificationSchema = z.object({
  id: z.string(),
  userId: z.string(),
  user: userSchema.optional(),
  category: NotificationCategorySchema.default("system"),
  type: z.string(),
  title: z.string().nullable().optional(),
  body: z.string().nullable().optional(),
  data: notificationDataSchema.optional(),
  link: z.string().nullable().optional(),
  icon: z.string().nullable().optional(),
  priority: NotificationPrioritySchema.default("normal"),
  isRead: z.boolean().default(false),
  readAt: z.coerce.date().nullable().optional(),
  isArchived: z.boolean().default(false),
  archivedAt: z.coerce.date().nullable().optional(),
  createdAt: z.coerce.date(),
});

export class NotificationDto extends createZodDto(notificationSchema) {}

/** Filtres de la liste paginée GET /notifications */
export const notificationFilterSchema = z.object({
  category: z.enum(NOTIFICATION_CATEGORIES).optional(),
  unreadOnly: z
    .string()
    .optional()
    .transform((v) => v === "true"),
  priority: z.enum(NOTIFICATION_PRIORITIES).optional(),
  limit: z.coerce.number().min(1).max(50).default(20),
  cursor: z.string().optional(), // pagination cursor (createdAt|id)
});
export class NotificationFilterDto extends createZodDto(notificationFilterSchema) {}

/** Réponse paginée (cursor-based) */
export const paginatedNotificationsSchema = z.object({
  items: z.array(notificationSchema),
  nextCursor: z.string().nullable(),
});
export class PaginatedNotificationsDto extends createZodDto(paginatedNotificationsSchema) {}

export class NotificationIdDto extends createZodDto(z.object({ id: z.string().min(1) })) {}

/** Compteur de non-lues */
export const unreadCountSchema = z.object({ count: z.number().int().min(0) });
export class UnreadCountDto extends createZodDto(unreadCountSchema) {}
